// extracted by mini-css-extract-plugin
export var addWidgetButton = "_m-6";
export var backButton = "_m-1";
export var legacyWidgetContainer = "_m-5";
export var pageContainer = "_m-2";
export var settingsContent = "_m-0";
export var widgetSubsectionItem = "_m-3";
export var widgetSubsectionItemContent = "_m-4";